<template>
  <div v-if="shouldDisplay">
    <Browse v-if="!selectedOffer" :device-name :listing-id />
    <SelectedOffer
      v-else
      :listing-id
      :offer="selectedOffer"
      @remove="updateInsurance"
    />
    <SelectionModal
      :device-name
      :insurance-offers
      :listing-id
      @update="updateInsurance"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import type { InsuranceOfferWithSelectedState } from '@backmarket/http-api'
import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'

import { DEFAULT_INSURANCE_ID } from '~/scopes/insurance/constants'

import Browse from './components/Browse/Browse.vue'
import SelectedOffer from './components/SelectedOffer/SelectedOffer.vue'
import SelectionModal from './components/SelectionModal/SelectionModal.vue'

const props = defineProps<{
  deviceName: string
  listingId: string
  insuranceOffers: InsuranceOfferWithSelectedState[]
}>()

const emit = defineEmits<{
  update: [updatedInsuranceOffers: InsuranceOfferWithSelectedState[]]
}>()

const experiments = useExperiments()

const selectedOffer = computed(() => {
  return (
    props.insuranceOffers.find(
      (offer) => offer.selected && offer.id.toString() !== DEFAULT_INSURANCE_ID,
    ) || null
  )
})

const shouldDisplay = computed(() => {
  return (
    experiments['experiment.checkoutInsuranceATC'] === 'insuranceATC' &&
    props.insuranceOffers.length > 0 &&
    (selectedOffer.value ? !selectedOffer.value.isCatchUpOffer : true)
  )
})

function updateInsurance(updatedOffer: InsuranceOfferWithSelectedState) {
  const updatedInsuranceOffers = props.insuranceOffers.reduce<
    InsuranceOfferWithSelectedState[]
  >((offers, offer) => {
    if (offer.id === updatedOffer.id) {
      return [...offers, updatedOffer]
    }

    return [...offers, offer]
  }, [])

  emit('update', updatedInsuranceOffers)
}
</script>
